<template>
  <div class="profile-panel" role="tablist">
    <div v-b-toggle="id" style="outline: none"
         class="profile-panel-header text-primary text-xl font-bold w-100 d-flex justify-content-between">
      <slot name="leading"></slot>
      <b-icon-chevron-down class="when-closed"></b-icon-chevron-down>
      <b-icon-chevron-up class="when-open"></b-icon-chevron-up>
    </div>
    <b-collapse :id="id" accordion="my-accordion" class="profile-panel-body" role="tabpanel">
      <!-- this is the area to display component -->
      <slot name="component"></slot>
    </b-collapse>
  </div>

</template>

<script>

export default {
  props: ["id"],

  data() {
    return {}
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>

.collapsed > .when-open,
.not-collapsed > .when-closed {
  display: none;
}

.profile-panel {
  margin-bottom: 10px;
  background: white;

  .profile-panel-header {
    padding: 5px 10px;
    align-items: center;
  }
}

span {
  background-color: #009e9a;
  width: 2px
}

.collapseBtn, .collapseBtn:focus, .collapseBtn:hover {
  background: #fff;
  border: 0 transparent
}

.header-card {
  border: 0 transparent;
  padding: 0 !important;
}

/* bellow is the styling for animation */
.slide-enter-active {
  -moz-transition-duration: 0.5s;
  -webkit-transition-duration: 0.5s;
  -o-transition-duration: 0.5s;
  transition-duration: 0.5s;
  -moz-transition-timing-function: linear;
  -webkit-transition-timing-function: linear;
  -o-transition-timing-function: linear;
  transition-timing-function: linear;
}

.slide-leave-active {
  -moz-transition-duration: 0.5s;
  -webkit-transition-duration: 0.5s;
  -o-transition-duration: 0.5s;
  transition-duration: 0.5s;
  -moz-transition-timing-function: linear;
  -webkit-transition-timing-function: linear;
  -o-transition-timing-function: linear;
  transition-timing-function: linear;
}

.slide-enter-to, .slide-leave {
  max-height: 1000px;
  overflow: hidden;
}

.slide-enter, .slide-leave-to {
  overflow: hidden;
  max-height: 0;
}

</style>
